<!-- Localisation Alert -->
<div *ngIf="!locationActivated" class="container mt-4">
	<div
		class="flex items-center justify-between gap-4 bg-primary/10 border border-primary/30 rounded-lg px-4 py-3 mb-4 text-primary text-sm">
		<span>
			Activez votre localisation pour voir les structures, pharmacies ou
			professionnels autour de vous.
		</span>
		<button class="bg-primary/25 hover:bg-primary/40 text-primary font-semibold px-4 py-2 rounded transition-colors"
			(click)="onActivateClick()">
			Activer
		</button>
	</div>
</div>

